/* !
 * solutions.js v1.0.0
 * Copyright, Connecty Inc.
 */
((FUNCTIONS) => {

	// [一覧] サマリー moreボタン開閉
	const solutionListSummaryMoreView = () => {
		const a = 'is-active';
		const o = 'is-open';
		let MAXH = 172;
		if (FUNCTIONS.va.region === '/jp/' || FUNCTIONS.va.region === '/cn/' || FUNCTIONS.va.region === '/kr/') {
			MAXH = 157;
		}
		let moreText = 'more';
		let closeText = 'close';
		if (FUNCTIONS.va.region === '/jp/') {
			moreText = 'もっと見る';
			closeText = '閉じる';
		}

		document.querySelectorAll('.rt_bn_solution_list figcaption').forEach(ele => {
			if (ele.clientHeight > MAXH) {
				ele.setAttribute('data-height', ele.clientHeight);
				ele.style.height = `${MAXH}px`;
				ele.nextElementSibling.classList.add(a);
			}
		});
		document.querySelectorAll('.rt_bn_solution_list .__more').forEach(ele => {
			ele.addEventListener('click', (e) => {
				e.preventDefault();
				if (ele.classList.contains(o)) {
					ele.previousElementSibling.style.height = `${MAXH}px`;
					ele.textContent = `... ${moreText}`;
					ele.classList.remove(o);
				} else {
					let thisH = ele.previousElementSibling.getAttribute('data-height');
					ele.previousElementSibling.style.height = `${Number(thisH) + 30}px`;
					ele.textContent = closeText;
					ele.classList.add(o);
				}
			});
		});
	};

	// [詳細] 主力のない項目のアンカーナビを削除する
	const removeAnchorNavEmptyBlock = () => {
		let anchorNav = document.querySelector('.mod-anchorNav');
		if (!document.querySelectorAll('.solutions-detail-details .s_solution_type')) {
			anchorNav.querySelector('li[data-target="details"]').remove();
		}
		if (!document.querySelector('.solutions-detail-case')) {
			anchorNav.querySelector('li[data-target="case"]').remove();
		}
		if (!document.querySelectorAll('.solutions-detail-related.rt_related_products_on .mod-prodList li').length) {
			anchorNav.querySelector('li[data-target="product"]').remove();
		}
		if (!document.querySelector('.solutions-detail-related.rt_related_solutions_div .__solutionLinks')) {
			anchorNav.querySelector('li[data-target="related"]').remove();
		}
	};

	// [詳細] 「このソリューションで解決できる課題」空要素の消し込み
	const removeEmptyNeeds = () => {
		document.querySelectorAll('.__needsList .sb_needs').forEach((ele) => {
			if (!ele.querySelector('.rt_pn_status')) { ele.remove(); }
		});
		if (document.querySelectorAll('.__needsList .sb_needs').length === 0) {
			document.querySelector('.__needsList').previousElementSibling.remove();
			document.querySelector('.__needsList').remove();
		}
	};

	// [詳細] 詳細パターン3（画像下）の画像がない場合消込
	const removeImgBlock = () => {
		document.querySelectorAll('.rt_s_solution_type_3 .__img').forEach((ele) => {
			if (!ele.querySelector('img').getAttribute('src').length) {
				ele.remove();
			}
		});
	};

	// [詳細] このソリューションで使用する製品の並び替え処理
	const adjustRelatedItemSort = () => {
		if (document.querySelector('.solutions-detail-related.__product')) {
			// data-hrefがあればリンク先変更
			document.querySelectorAll('.solutions-detail-related.__product a').forEach(ele => {
				if (ele.getAttribute('data-href')) {
					ele.setAttribute('href', ele.getAttribute('data-href'));
				}
			});

			// 並び替え処理
			let adjustItemList = [], relatedItems;
			let itemID = FUNCTIONS.va.pathname.replace(FUNCTIONS.va.region, '').split('/')[1];
			// be・ca の並べ替え用APIは言語階層を含まない
			const ajaxRegion = FUNCTIONS.va.region.replace(/^\/(be|ca)\/[^/]+\/$/, '/$1/');
			let jsonURL = `${ajaxRegion}ajax/solutions/rel_list_order/${itemID}`;
			fetch(jsonURL).then(response => response.json()).then(data => {
				relatedItems = document.querySelectorAll('.solutions-detail-related.__product .rt_bn_related_p1');
				if (relatedItems.length) {
					data.solution_Base[0].sb_related_p1.forEach(keys => {
						relatedItems.forEach(item => {
							if (item.querySelector('a').getAttribute('data-id').indexOf(keys._key) !== -1) {
								adjustItemList.push(item);
							}
						});
					});
					document.querySelectorAll('.solutions-detail-related.__product .rt_related_p1_on .__links li').forEach(ele => { ele.remove(); });
					adjustItemList.forEach(ele => {
						document.querySelector('.solutions-detail-related.__product .rt_related_p1_on .__links').append(ele);
					});
				}

				adjustItemList = [];
				relatedItems = document.querySelectorAll('.solutions-detail-related.__product .rt_bn_related_p2');
				if (relatedItems.length) {
					data.solution_Base[0].sb_related_p2.forEach(keys => {
						relatedItems.forEach(item => {
							if (item.querySelector('a').getAttribute('data-id').indexOf(keys._key) !== -1) {
								adjustItemList.push(item);
							}
						});
					});
					document.querySelectorAll('.solutions-detail-related.__product .rt_related_p2_on .__links li').forEach(ele => { ele.remove(); });
					adjustItemList.forEach(ele => {
						document.querySelector('.solutions-detail-related.__product .rt_related_p2_on .__links').append(ele);
					});
				}

				adjustItemList = [];
				relatedItems = document.querySelectorAll('.solutions-detail-related.__product .rt_bn_related_p3');
				if (relatedItems.length) {
					data.solution_Base[0].sb_related_p3.forEach(keys => {
						relatedItems.forEach(item => {
							if (item.querySelector('a').getAttribute('data-id').indexOf(keys._key) !== -1) {
								adjustItemList.push(item);
							}
						});
					});
					document.querySelectorAll('.solutions-detail-related.__product .rt_related_p3_on .__links li').forEach(ele => { ele.remove(); });
					adjustItemList.forEach(ele => {
						document.querySelector('.solutions-detail-related.__product .rt_related_p3_on .__links').append(ele);
					});
				}

				adjustItemList = [];
				relatedItems = document.querySelectorAll('.solutions-detail-related.__product .rt_bn_related_p4');
				if (relatedItems.length) {
					data.solution_Base[0].sb_related_p4.forEach(keys => {
						relatedItems.forEach(item => {
							if (item.querySelector('a').getAttribute('data-id').indexOf(keys._key) !== -1) {
								adjustItemList.push(item);
							}
						});
					});
					document.querySelectorAll('.solutions-detail-related.__product .rt_related_p4_on .__links li').forEach(ele => { ele.remove(); });
					adjustItemList.forEach(ele => {
						document.querySelector('.solutions-detail-related.__product .rt_related_p4_on .__links').append(ele);
					});
				}

				adjustItemList = [];
				relatedItems = document.querySelectorAll('.solutions-detail-related.__product .rt_bn_related_p5');
				if (relatedItems.length) {
					data.solution_Base[0].sb_related_p5.forEach(keys => {
						relatedItems.forEach(item => {
							if (item.querySelector('a').getAttribute('data-id').indexOf(keys._key) !== -1) {
								adjustItemList.push(item);
							}
						});
					});
					document.querySelectorAll('.solutions-detail-related.__product .rt_related_p5_on .__links li').forEach(ele => { ele.remove(); });
					adjustItemList.forEach(ele => {
						document.querySelector('.solutions-detail-related.__product .rt_related_p5_on .__links').append(ele);
					});
				}

				adjustItemList = [];
				relatedItems = document.querySelectorAll('.solutions-detail-related.__product .rt_bn_related_p6');
				if (relatedItems.length) {
					data.solution_Base[0].sb_related_p6.forEach(keys => {
						relatedItems.forEach(item => {
							if (item.querySelector('a').getAttribute('data-id').indexOf(keys._key) !== -1) {
								adjustItemList.push(item);
							}
						});
					});
					document.querySelectorAll('.solutions-detail-related.__product .rt_related_p6_on .__links li').forEach(ele => { ele.remove(); });
					adjustItemList.forEach(ele => {
						document.querySelector('.solutions-detail-related.__product .rt_related_p6_on .__links').append(ele);
					});
				}

			});
		}
	};

	if (document.querySelector('.solutions-detail')) {
		removeAnchorNavEmptyBlock();
		removeEmptyNeeds();
		removeImgBlock();
		adjustRelatedItemSort();
	} else {
		solutionListSummaryMoreView();
	}

})(window.FUNCTIONS);
